<template>
  <div>
    <div class="container">
      <div class="row text-left">
        <div class="col-12">
          <h3>Configurar domínio personalizado</h3>
        </div>
        <div class="col-12">
          <p>
            Quando um {{ appName }} é criado, automaticamente você terá um
            domínio padrão, onde você poderá visualizar a criação e alterações
            de seu Site, mas o ideal é utilizar um domínio personalizado, seu
            endereço na internet para que seja facilmente encontrado.
          </p>

          <h3>Se você não tem um domínio</h3>
          <p>
            Recomendamos que faça o registro através do
            <a
              href="https://registro.br/"
              target="_blank"
              rel="noopener noreferrer"
            >Registro.br</a>
            ou
            <a
              href="https://br.godaddy.com/"
              target="_blank"
              rel="noopener noreferrer"
            >Go Daddy</a>. Neles, você pode consultar a disponibilidade e valor do domínio
            que deseja.
          </p>
          <img src="../../assets/img/faq/Dominio-Consulta.gif" class="img-fluid" alt />
          <p>
            Estando disponível, é só seguir o passo a passo da compra e depois
            continuar a seguir este mesmo tutorial para fazer a configuração.
          </p>

          <h3>Se você já tem um domínio</h3>
          <p class="alert-text">
            ATENÇÃO: se você utiliza serviços de servidor externo, emails
            personalizados, cPainel, eles deverão ser reconfigurados.
          </p>
          <ol class="faq-order-list">
            <li>
              No painel do seu Site, clique no menu
              <span>Domínios</span> ou em
              <span>Configurar domínio personalizado</span>
            </li>
            <li>
              Clique em
              <span>Configurar domínio</span>
            </li>
            <li>
              Confirme que tem domínio e insira o
              <span>endereço que seu Site</span> terá ->
              <span>Salvar domínio</span>
            </li>
            <li>
              É necessário que direcione seu domínio para nosso servidor. Para
              isso, faça as configurações de acordo com a empresa em que
              registrou:
            </li>
          </ol>
          <br />
          <h4>Registro.br</h4>
          <img src="../../assets/img/faq/Registrobr1.gif" class="img-fluid" alt />
          <p class="alert-text">Passo a passo Registro.br:</p>
          <ul>
            <li>
              Faça o
              <span>login</span>
            </li>
            <li>
              Clique no
              <span>domínio</span> desejado
            </li>
            <li>
              Em
              <span>DNS</span>, clique em
              <span>Editar Zona</span>. (Caso não
              encontre essa opção, clique em
              <span>Alterar servidores DNS</span> e em seguida
              <span>Utilizar DNS do Registro.br -> Sim</span>. Pode ser
              necessário aguardar algumas horas até finalizar o processo de
              transição)
            </li>
          </ul>
          <img src="../../assets/img/faq/Registrobr2.png" class="img-fluid" alt />
          <ul>
            <li>
              Na tela de
              <span>Edição de Zona</span>, clique em
              <span>Modo Avançado</span>
            </li>
            <p class="alert-text m-0">Tipo "A"</p>
            <p class="alert-text m-0">Valor: Vazio | Endereço IP: 18.229.165.166</p>
          </ul>
          <img src="../../assets/img/faq/Registrobr3.png" class="img-fluid" alt />
          <ul>
            <p class="alert-text m-0">Tipo "CNAME"</p>
            <p class="alert-text m-0">Valor: www | Nome do servidor: seudominio.com.br</p>
          </ul>
          <p>*substitua "seudominio.com.br" pelo seu endereço personalizado</p>
          <img src="../../assets/img/faq/Registrobr4.png" class="img-fluid" alt />
          <ul>
            <li>
              No avançado, clique em
              <span>Nova Entrada</span>, adicione as
              <span>informações -> Adicionar</span>
            </li>
            <li>
              Clique em
              <span>Salvar</span>
            </li>
          </ul>
          <p class="alert-text">
            Obs: Após a criação/alteração, pode levar algumas horas para se
            propagar.
          </p>
          <br />
          <h4>GoDaddy</h4>
          <img src="../../assets/img/faq/GoDaddy1.gif" class="img-fluid" alt />
          <p class="alert-text">Passo a passo GoDaddy:</p>
          <ul>
            <li>
              Faça o
              <span>login</span>
            </li>
            <li>
              No
              <span>domínio</span> que deseja, clique em
              <span>Gerenciar</span>
            </li>
            <li>
              Em seguida,
              <span>Gerencias DNS -> Adicionar</span> (Caso não
              encontre essa opção, clique em
              <span>Alterar</span> Servidores de
              nomes e em seguida
              <span>Padrão -> Salvar</span>. Pode ser
              necessário aguardar algumas horas até finalizar o processo de
              transição)
            </li>
            <li>
              Clique em
              <span>Adicionar</span>, insira as informações ->
              <span>Salvar</span>
            </li>
            <p class="alert-text">Tipo "A"</p>
            <p class="alert-text">Host: @ |Aponta para: 18.229.165.166</p>
          </ul>
          <img src="../../assets/img/faq/GoDaddy2.png" class="img-fluid" alt />
          <ul>
            <p class="alert-text">Tipo "CNAME"</p>
            <p class="alert-text">Host: www |Aponta para: @</p>
          </ul>*substitua "@" pelo seu endereço personalizado
          <img
            src="../../assets/img/faq/GoDaddy3.png"
            class="img-fluid"
            alt
          />
          <p class="alert-text">
            Obs: Após a criação/alteração, pode levar algumas horas para se
            propagar.
          </p>

          <br />
          <h4>Outros</h4>
          <ul>
            <li>
              Acesse a área de gerenciamento de DNS do seu domínio e adicione as
              seguintes informações:
            </li>
          </ul>
          <p class="alert-text m-0">Tipo "A"</p>
          <p class="m-0">Valor: @ ou Vazio | Caminho: 18.229.165.166</p>
          <p class="alert-text m-0">Tipo "CNAME"</p>
          <p class="m-0">Valor: www | Caminho: seudominio.com.br</p>
          <br />
          <p>
            Obs: Após a criação/alteração, pode levar algumas horas para se
            propagar.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    appName() {
      if (this.$store.state.application.app_name) {
        return this.$store.state.application.app_name;
      } else {
        return "site";
      }
    },
  },
  beforeCreate() {
    // this.$store.dispatch("VERIFY_TOKEN");
    //this.$store.dispatch("VERIFY_SITE");
  },
};
</script>

<style scoped>
ol {
  margin: 0 0 1.5em;
  counter-reset: item;
}

ol > li {
  margin: 0;
  padding: 0 0 0 2em;
  text-indent: -2em;
  list-style-type: none;
  counter-increment: item;
}

ol > li:before {
  display: inline-block;
  padding-right: 0.5em;
  font-weight: bold;
  text-align: right;
  content: counter(item) ".";
}
li > span,
.alert-text {
  font-weight: 700;
}
img {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/ConfigurarDominio.vue